import { AwtDateFilter } from '../model/awaiting-transaction';

export function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function normalizeAwtDateFilter(value: AwtDateFilter): string {
  if (value === null || value === undefined || value === '' || value === '0') {
    return '0';
  }
  if (value instanceof Date && !isNaN(value.getTime())) {
    return formatLocalYmd(value);
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
      return trimmed.slice(0, 10);
    }
    const parsed = new Date(trimmed);
    if (!isNaN(parsed.getTime())) {
      return formatLocalYmd(parsed);
    }
  }
  return '0';
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Added formatLocalYmd() and normalizeAwtDateFilter() for ATA list date filters. Previous behavior: No ATA date helper; toISOString().slice(0,10) converts to UTC and shifts SAST midnight to the previous calendar day. New behavior: Dates use local year/month/day as YYYY-MM-DD; null/empty/'0' become '0' (no filter); strings already YYYY-MM-DD keep the first 10 characters. Reason: MBengine /awt/get rejects Date.toString() and must receive YYYY-MM-DD or '0'. Context: ATA guide 2026-07-27 date fix; portaladmin ATA service duplication. Impact: AwaitingTransactionService normalizes filters before POST; callers may pass Date objects. - 2026-08-20 - HE
